import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ApiResponseState<T> {
  data: T[];
}

function createApiResponseSlice<T>(sliceName: string) {
  const initialState: ApiResponseState<T> = {
    data: [],
  };

  return createSlice({
    name: sliceName,
    initialState,
    reducers: {
      setData(state, action: PayloadAction<T[]>) {
        state.data = action.payload;
      },
      updateData(state, action: PayloadAction<T>) {
        const index = state.data.findIndex(
          (item) => (item as any).id === (action.payload as any).id,
        );
        if (index !== -1) {
          state.data[index] = { ...state.data[index], ...action.payload };
        }
      },
      removeData(state, action: PayloadAction<{ id: string | number }>) {
        state.data = state.data.filter(
          (item) => (item as any).id !== action.payload.id,
        );
      },
      clearData(state) {
        state.data = [];
      },
    },
  });
}

export default createApiResponseSlice;
